module.exports = __webpack_public_path__ + "static/media/der - copia.4f3995bb.svg";